var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.formContext.isLoaded
    ? _c(
        "csp-desktop-info-card",
        {
          attrs: {
            cols: _vm.cols,
            "form-context": _vm.formContext,
            icon: "inticon-autoclaim_assign",
            title: "Aktenprozess",
          },
          on: { save: _vm.saveRecordProcess },
        },
        [
          _c("h2", [_vm._v("Haftpflicht")]),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "CSP Vollmacht aktivieren",
                  property: "enableCspAuthorityDocumentCasualty",
                  type: "checkbox",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "CSP ausblenden",
                  property: "shouldHideCspCasualty",
                  type: "checkbox",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-12",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Schadensdienstleister",
                  "options-loader": _vm.loadOptions(
                    "damageServiceProvidersByCarDealer",
                    { carDealerId: _vm.firmId }
                  ),
                  property: "damageServiceProviderCasualty",
                  type: "autocomplete",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.formContext.form.data.damageServiceProviderCasualty,
                    expression:
                      "formContext.form.data.damageServiceProviderCasualty",
                  },
                ],
                staticClass: "col-12",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "AH darf Akte direkt an RA übergeben",
                  property: "canRecordSkipDspCasualty",
                  type: "checkbox",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("h2", [_vm._v("Kasko")]),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "CSP Vollmacht aktivieren",
                  property: "enableCspAuthorityDocumentComprehensive",
                  type: "checkbox",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "CSP ausblenden",
                  property: "shouldHideCspComprehensive",
                  type: "checkbox",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-12",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Schadensdienstleister",
                  "options-loader": _vm.loadOptions(
                    "damageServiceProvidersByCarDealer",
                    { carDealerId: _vm.firmId }
                  ),
                  property: "damageServiceProviderComprehensive",
                  type: "autocomplete",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.formContext.form.data
                        .damageServiceProviderComprehensive,
                    expression:
                      "formContext.form.data.damageServiceProviderComprehensive",
                  },
                ],
                staticClass: "col-12",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "AH darf Akte direkt an RA übergeben",
                  property: "canRecordSkipDspComprehensive",
                  type: "checkbox",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Abtretung ausblenden",
                  property: "shouldNotOverrideComprehensivePaymentOrder",
                  type: "checkbox",
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }